module.exports = __webpack_public_path__ + "static/media/HKC.5f888a76.pdf";